<h2 mat-dialog-title>
  Sélectionner un ensemble fonctionnel provenant d'un projet
</h2>
<app-list-set
  [actions]="['select', 'search']"
  (select)="close($event)">
</app-list-set>
